<script setup lang="ts">
import { computed } from "vue";
const props = withDefaults(
  defineProps<{
    label: string;
    value?: string | number;
    unit?: string;
    delta?: string;
    trend?: "up" | "down";
    variant?: "card" | "sunken";
    size?: "sm" | "md";
  }>(),
  { variant: "card", size: "md" },
);
const cls = computed(() => ["cw-stat", props.variant === "sunken" ? "cw-stat--sunken" : ""]);
const valueCls = computed(() => [
  "cw-stat__value",
  props.size === "sm" ? "cw-stat__value--sm" : "",
]);
</script>
<template>
  <div :class="cls">
    <span class="cw-stat__label">{{ label }}</span>
    <span :class="valueCls">
      <slot>{{ value }}</slot>
      <span
        v-if="unit"
        class="cw-stat__unit"
      >{{ unit }}</span>
    </span>
    <span
      v-if="delta"
      class="cw-stat__delta"
      :class="trend === 'down' ? 'cw-stat__delta--down' : 'cw-stat__delta--up'"
    >{{ delta }}</span>
  </div>
</template>
